export enum CustomerCategoryEnum {
  Default = 'DEFAULT',
  Telco = 'TELCO',
  Water = 'WATER'
}
